import { SupplierRange } from "../../types/supplierRange";

export function findRange(id:string, ranges: SupplierRange[]) : SupplierRange | undefined  {
    return ranges.find((bp) => bp.id === id);
}